import { FrequencyEnumOptions } from "@boundless/bl-api-client/public/models/FrequencyEnumLabels"
import { useFormContext, useWatch } from "react-hook-form"

import { FormChipGroup } from "@/components/form-elements/FormChipGroup"
import { FormInputNumeric } from "@/components/form-elements/FormInputNumeric"
import {
  FormMoneyInput,
  FR_CONTROL_HEIGHT,
} from "@/components/form-elements/FormMoneyInput"
import {
  EMPTY_OFFER,
  type FundReadyIntakeFormValues,
} from "@/lib/fundready/schema"

import type { FrequencyEnum } from "@boundless/bl-api-client/public/models/FrequencyEnum"

const OFFER_ENTERED_OPTIONS = [
  { value: true, label: "Yes, compare my offer" },
  { value: false, label: "No offer yet — skip" },
]

export function StepOffer() {
  const form = useFormContext<FundReadyIntakeFormValues>()
  const offerEntered = useWatch({ control: form.control, name: "offerEntered" })

  return (
    <>
      <FormChipGroup<FundReadyIntakeFormValues, boolean>
        name="offerEntered"
        options={OFFER_ENTERED_OPTIONS}
        onChange={(value) => {
          form.setValue("offer", value ? EMPTY_OFFER : null)
        }}
      />

      {offerEntered && (
        <>
          <FormMoneyInput<FundReadyIntakeFormValues>
            name="offer.advance"
            label="Advance / loan amount"
            placeholder="$100,000"
          />
          <FormMoneyInput<FundReadyIntakeFormValues>
            name="offer.payback"
            label="Total payback amount"
            placeholder="$132,000"
          />
          <FormInputNumeric<FundReadyIntakeFormValues>
            name="offer.termMonths"
            label="Term (months)"
            placeholder="6"
            inputClassName={FR_CONTROL_HEIGHT}
          />
          <FormChipGroup<FundReadyIntakeFormValues, FrequencyEnum>
            name="offer.frequency"
            label="Payment frequency"
            options={FrequencyEnumOptions}
          />
          <FormMoneyInput<FundReadyIntakeFormValues>
            name="offer.fees"
            label="Origination & other fees (deducted from proceeds)"
            placeholder="$3,000"
          />
        </>
      )}
    </>
  )
}
